/* unplugin-vue-components disabled */import { ElIcon as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-19688106"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line1"
}, null, -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line2"
}, null, -1));
const _hoisted_3 = {
  class: "user"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "用户", -1));
import UserIcon from '~icons/custom/user';
export default /*#__PURE__*/_defineComponent({
  __name: 'user',
  setup(__props) {
    const router = useRouter();
    const handleClick = item => {
      if (item === 'user') {
        router.push('/user-center');
      }
      if (item === 'setting') {
        router.push('/setting');
      }
    };
    return (_ctx, _cache) => {
      const _component_el_icon = __unplugin_components_0;
      return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: _normalizeClass(['user-item', _ctx.$route.path === '/user-center' ? 'active' : '']),
        onClick: _cache[0] || (_cache[0] = $event => handleClick('user'))
      }, [_createVNode(_component_el_icon, {
        size: 24,
        color: _ctx.$route.path === '/user-center' ? '#fff' : '#C5D3FC'
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(UserIcon))))]),
        _: 1
      }, 8, ["color"]), _hoisted_4], 2)])], 64);
    };
  }
});